import { useMemo } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

const useDisplay = () => {
  const mobile = useMediaQuery("(max-width:820px)");
  const displayStyle = useMemo(() => {
    return mobile ? "column.center.flex-start" : "row.flex-start.flex-start";
  }, [mobile]);

  return displayStyle;
};

export default useDisplay;
